import type {
  ConfirmStripeSessionRequest,
  ConfirmStripeSessionResponse,
  CreateCheckoutSessionRequest,
  CreateCheckoutSessionResponse,
  ValidateUploadRequest,
  ValidateUploadResponse,
  StartIntakeRequest,
  StartIntakeResponse,
  StatusResponse,
  SubmitIntakeRequest,
  SubmitIntakeResponse,
  UploadSessionRequest,
  UploadSessionResponse,
} from "@/types/api";
import { createHttp } from "./http";
import type { IntakeApi } from "./types";

/**
 * Real HTTP client for the intake/commerce BFF. In production the BFF is linked
 * to the Static Web App, so `baseUrl` is the same-origin `/api`.
 */
export function createHttpClient(baseUrl: string): IntakeApi {
  const http = createHttp(baseUrl);
  return {
    startIntake: (req: StartIntakeRequest) =>
      http.post<StartIntakeResponse>("/intake/start", req),

    createUploadSession: (req: UploadSessionRequest) =>
      http.post<UploadSessionResponse>("/intake/upload-session", req),

    validateUpload: (req: ValidateUploadRequest) =>
      http.post<ValidateUploadResponse>("/intake/validate-upload", req),

    submitIntake: (req: SubmitIntakeRequest) =>
      http.post<SubmitIntakeResponse>("/intake/submit", req),

    getStatus: (reportId: string) =>
      http.get<StatusResponse>(`/intake/status/${encodeURIComponent(reportId)}`),

    createCheckoutSession: (req: CreateCheckoutSessionRequest) =>
      http.post<CreateCheckoutSessionResponse>("/create-checkout-session", req),

    confirmStripeSession: (req: ConfirmStripeSessionRequest) =>
      http.post<ConfirmStripeSessionResponse>("/stripe/confirm-session", req),
  };
}
